import React, { useState } from 'react'
import { Panel, Row, Col } from 'rsuite'
export default function ViewSettingFormListWidget({ objects, ...props }) {
  //const [schema, setSchema] = useState(_schema)

  const { header, collapsible, defaultExpanded, bordered } = props

  const emptyValue = <>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</>

  const displayCompt = (data, tabRight) => {
    // console.log('data : ', data)
    return (
      <>
        {data?.map((item, index) => {
          let inputObj = (
            <p>
              {!tabRight ? `${index + 1}. ` : ''}
              {item.section1}
              <b>
                <u> {item.result || (item.resultType == '1' ? emptyValue : '')} </u>
              </b>{' '}
              {item.resultType == '1' && (item.unit || '')}
              {item?.moreInputs?.map((e) => {
                return (
                  <label style={{ marginLeft: 10 }}>
                    {e.section1}
                    <u>{e.result || (e.resultType == '1' ? emptyValue : '')}</u>
                    {e.resultType == '1' && (e.unit || '')}
                  </label>
                )
              })}
              {item.childs && displayCompt(item.childs, true)}
            </p>
          )

          return (
            <Row style={{ marginLeft: tabRight ? 20 : undefined, marginBottom: 10 }}>
              <Col xs={24} sm={24} md={24} lg={24}>
                {inputObj}
              </Col>
            </Row>
          )
        })}
      </>
    )
  }

  return (
    <Panel
      header={header || ''}
      collapsible={collapsible}
      defaultExpanded={defaultExpanded}
      bordered={bordered}
    >
      <div style={{ marginTop: -10 }}>{displayCompt(objects, false)}</div>
    </Panel>
  )
}
